export const getLockers = cuds => [...new Set(cuds.map((e) => e.placeName))].sort();

export const filterLockers = (filteredData, originType, locker) => {
  return filteredData.filter(data => data.placeName === locker && data.originType.includes(originType));
} 
